<template>
  <div class="p-0">
    <div v-if="anyPendingRequestAvailable">
      <v-card
        v-for="(item, index) in organizationsPendingRequests"
        :key="index"
        color="white"
        elevation="0"
        class="container"
      >
        <div class="details-container mb-3">
          <v-card-text>
            <p class="title-text-style">
              Organization:
              <font class="value-text-style">
                {{ item.organization.name }}
              </font>
            </p>
            <p class="title-text-style">
              Company:
              <font class="value-text-style">
                {{ item.company.name }}
              </font>
            </p>
            <p class="title-text-style">
              Role: {{ item.app_user_role | formatRole }}
            </p>
            <p class="title-text-style">
              Type:
              <font class="title-text-style type-style">
                {{ item.types | arrangePretty }}
              </font>
            </p>
            <v-btn
              v-if="item.created_by !== 'sign-up'"
              x-small
              elevation="0"
              color="#64CA7F"
              class="mt-3"
              @click="
                acceptRequest(item, item.organization.external_id, item.types)
              "
            >
              Accept
            </v-btn>
            <br>
            <v-chip
              v-if="
                user.app_user.external_id === item.external_id &&
                  item.created_by === 'sign-up'
              "
              dark
              rounded
              outlined
              color="#e6e6e6"
              small
              class="status-style"
            >
              Pending
            </v-chip>
          </v-card-text>
        </div>
        <v-spacer />
      </v-card>
    </div>

    <div
      v-else
      class="pa-0"
    >
      <v-card
        color="#FFF"
        elevation="0"
        class="empty-alert-div"
      >
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No requests found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
export default {
  name: 'OrganizationsPendingRequest',
  components: {
    'centre-spinner': spinner,
  },
  filters: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    arrangePretty (val) {
      if (Array.isArray(val)) {
        return val
          .map((type) => (type === 'staff' ? 'Site Manager' : type))
          .join(', ');
      }
      return val;
    },
    formatRole (val) {
      if (val === 'site-manager') {
        return 'Site Manager';
      } else if (val === 'contractor') {
        return 'Contractor';
      } else {
        return 'Worker';
      }
    },
  },
  data: () => ({
    loading: false,
    selectedOrganization: null,
  }),
  computed: {
    organizationsPendingRequests () {
      return this.$store.getters[
        'organization/getOrganizationsPendingRequests'
      ];
    },
    documentVerificationCheck () {
      return this.orgSettings.document_verification;
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    anyPendingRequestAvailable () {
      if (this.organizationsPendingRequests.length !== 0) {
        return true;
      }
      return false;
    },
    user () {
      return this.$store.getters.getUser;
    },
  },
  async mounted () {
    this.loading = true;
    await this.getOrganizationsPendingRequests();
    this.loading = false;
  },
  methods: {
    async getOrganizationsPendingRequests () {
      this.loading = true;
      await this.$store.dispatch(
        'organization/fetchOrganizationsPendingRequests',
        {
          params: {
            requestStatus: 'pending',
          },
        },
      );
      this.loading = false;
    },
    async acceptRequest (organization, organizationExternalId, types) {
      this.selectedOrganization = organization;
      this.loading = true;
      await this.$store.dispatch(
        'organization/fetchOrganizationSettings',
        this.selectedOrganization,
      );
      this.loading = false;
      if (types.includes('worker') && this.documentVerificationCheck) {
        this.$router.push(
          `/organizations/${organizationExternalId}/accept-request`,
        );
      } else {
        this.loading = true;
        await this.$store
          .dispatch('organization/acceptOrganizationRequest', {
            organizationExtId: {
              organization_id: organizationExternalId,
            },
          })
          .then((res) => {
            this.$store.dispatch(
              'alert/onAlert',
              {
                message: 'Request Accepted Successfully',
                type: Constants.ALERT_TYPE_SUCCESS,
              },
              { root: true },
            );
            this.$store.commit(
              'setSeletedOrganization',
              this.selectedOrganization,
            );
            location.reload();
          });
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.container {
  border-radius: 10px !important;
  padding: 0px !important;
}

.text-card-style {
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-content: center;
  align-items: center;
}

p {
  margin-bottom: 0px;
}

.center-items {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sub-container {
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  right: 0;
  float: right;
}
.details-container {
  width: 100% !important;
  border-radius: 10px;
}
.type-style {
  color: #ff3700;
  text-transform: capitalize;
}
.v-card .v-card_text {
  padding: 0px !important;
}
</style>
